import http from '../utils/http';

function contact(data) {
  return http.post('contact', data);
}

export default contact;
